import React, { useEffect, useState } from 'react';
import Hidden from '@material-ui/core/Hidden';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import socket from '../../socket';

import { Sidebar, BottomNav, ProviderSidebar, Text, Progress, Alert } from '../index';

import { StyledMainLayoutContainer, StyledContentContainer } from './style';

import { alertNotification } from '../../redux/stateActions';

const MainLayout = ({ children, role }) => {
    const dispatch = useDispatch();

    const user = useSelector((state) => state.user);

    const [loading, setLoading] = useState(false);
    const [disconnected, setDisconnected] = useState({});

    useEffect(() => {
        // fire when reconnect after disconnect
        socket.on('connect', () => {
            console.log('connect');
        });
        socket.on('disconnect', () => {
            console.log('disconnect');
            setLoading(true);
            setDisconnected({ severity: 'error', content: 'Reconnecting...', duration: null });
        });

        socket.on('connected', () => {
            console.log('connected');
            setLoading(false);
            setDisconnected({ severity: 'success', content: 'Reconnected', duration: 3000 });
        });

        socket.on('newNotification', (data) => {
            dispatch(
                alertNotification(
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <Text $color="white" $fontSize="14px" $medium>
                            {data.title}
                        </Text>
                        <Text $color="white" $fontSize="12px" $ellipsis>
                            {data.description}
                        </Text>
                    </div>
                )
            );
        });
    }, []);

    useEffect(() => {
        const role = localStorage.getItem('role');

        if (!_.isEmpty(user)) {
            if (['Provider', 'Provider Admin', 'Admin'].includes(role)) {
                socket.emit('providerOnline', {
                    userId: user.id,
                    staffId: user.staff.id,
                    hospitalId: user.staff.hospital.id,
                });

                socket.on('forceSignOut', () => {
                    console.log('forceSignOut');
                    localStorage.clear();
                    window.location.replace('/provider/signin');
                });
            }
            if (role === 'Patient') {
                socket.emit('patientOnline', {
                    userId: user.id,
                    patientId: user.patient.id,
                });

                socket.on('forceSignOut', () => {
                    console.log('forceSignOut');
                    localStorage.clear();
                    window.location.replace('/signin');
                });
            }
        }
    }, [user]);

    return (
        <StyledMainLayoutContainer id="StyledMainLayoutContainer">
            {loading && <Progress style={{ zIndex: 9999 }} />}
            {!_.isEmpty(disconnected) && (
                <Alert
                    severity={disconnected.severity}
                    open={!_.isEmpty(disconnected)}
                    duration={disconnected.duration}
                    onClose={() => setDisconnected({})}
                    style={{ zIndex: 10000 }}
                >
                    {disconnected.content}
                </Alert>
            )}
            {_.isEmpty(user) ? (
                <></>
            ) : (
                <>
                    {['Provider', 'Admin', 'Provider Admin'].includes(role) && (
                        <ProviderSidebar user={user} />
                    )}

                    {role === 'Patient' && (
                        <Hidden smDown>
                            <Sidebar />
                        </Hidden>
                    )}

                    <StyledContentContainer id="StyledContentContainer">
                        {children}

                        {role === 'Patient' && (
                            <Hidden mdUp>
                                <BottomNav />
                            </Hidden>
                        )}
                    </StyledContentContainer>
                </>
            )}
        </StyledMainLayoutContainer>
    );
};

MainLayout.propTypes = {
    children: PropTypes.any.isRequired,
    role: PropTypes.string.isRequired,
};

export default MainLayout;
